/**
 * Master (API)
 * Master 関連のAPI
 */
import session from './session'

var uri = process.env.API_ENDPOINT

export default {
  // PartsPrice API
  createPartsPrice (data) {
    return session.post(uri + '/api/mt/parts_price/', data)
  },
  getPartsPrice (pk) {
    if (pk) return session.get(uri + '/api/mt/parts_price/' + pk)
    else return session.get(uri + '/api/mt/parts_price/')
  },
  updatePartsPrice (data) {
    return session.patch(uri + '/api/mt/parts_price/' + data.pk, data)
  },
  deletePartsPrice (pk) {
    return session.delete(uri + '/api/mt/parts_price/' + pk)
  },
  // billing API
  getBilling (pk) {
    if (pk) return session.get(uri + '/api/mt/billing/' + pk)
    else return session.get(uri + '/api/mt/billing/')
  },
  updateBilling (data) {
    return session.patch(uri + '/api/mt/billing/' + data.pk, data)
  },
  // send Email API
  sendEmail (data) {
    return session.post(uri + '/api/mt/send_email/', data)
  },
  // send Email Content API
  sendEmailContent (data) {
    return session.post(uri + '/api/mt/send_email_content/', data)
  },
  // フロント障害調査用
  notifyTool (data) {
    return session.post(uri + '/api/mt/notify_tool/', data)
  }
}


// WEBPACK FOOTER //
// ./src/api/master.js